import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataItemsValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'array',
            empty: false,
            mandatory: false
        };
    }
}
